import {
  Dialog,
  CircularProgress,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import { createContext, useState, type FC, type ReactNode } from 'react';

type DialogContextType = {
  dialogOpen: boolean;
  handleDialogOpen: (content: ReactNode, title: string) => void;
  handleDialogClose: () => void;
};

export const DialogContext = createContext<DialogContextType>({
  dialogOpen: false,
  handleDialogOpen: () => {},
  handleDialogClose: () => {},
});

export const DialogContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState<ReactNode>();
  const [dialogTitle, setDialogTitle] = useState<string>();
  const handleDialogOpen = (content: ReactNode, title: string) => {
    setDialogOpen(true);
    setDialogContent(content);
    setDialogTitle(title);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <DialogContext.Provider
      value={{
        dialogOpen,
        handleDialogOpen,
        handleDialogClose,
      }}>
      <Dialog
        fullWidth
        maxWidth="md"
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>{dialogContent}</DialogContent>
        {/* <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Disagree
          </Button>
          <Button onClick={handleClose} autoFocus>
            Agree
          </Button>
        </DialogActions> */}
      </Dialog>
      {children}
    </DialogContext.Provider>
  );
};
